export const INITIAL_MOBILE_NAV_STATE: MobileNavState = {
	isSticky: false,
	isHidden: false,
	openNavItem: null,
	showSearch: false,
	isMenuOpen: false,
	isScrolled: false,
	topOffset: 0,
	areTransitionsSuspended: false,
};

export const mobileNavReducer = (
	state: MobileNavState,
	action: MobileNavAction,
): MobileNavState => {
	switch (action.type) {
		case 'nav_position_updated':
			return {
				...state,
				isSticky: action.isSticky,
				isHidden: action.isHidden,
				isScrolled: action.isScrolled,
				topOffset: action.topOffset,
			};
		case 'toggled_search': {
			const nextShowSearch = action.showSearch ?? !state.showSearch;

			return {
				...state,
				isMenuOpen: false,
				openNavItem: null,
				showSearch: nextShowSearch,
				areTransitionsSuspended: true,
			};
		}
		case 'toggled_mobile_menu': {
			const nextIsMenuOpen = !state.isMenuOpen;

			return {
				...state,
				isMenuOpen: nextIsMenuOpen,
				openNavItem: null,
				showSearch: false,
				areTransitionsSuspended: true,
			};
		}
		case 'toggled_subnav_for_item':
			return {
				...state,
				openNavItem:
					state.openNavItem === action.navId ? null : (action.navId ?? null),
			};
		case 'clicked_or_focused_outside':
			return {
				...state,
				isMenuOpen: false,
				openNavItem: null,
				showSearch: false,
				areTransitionsSuspended: true,
			};
		case 'transitions_resumed':
			return { ...state, areTransitionsSuspended: false };
		case 'desktop_viewport_entered':
			return {
				...state,
				isMenuOpen: false,
				openNavItem: null,
				showSearch: false,
			};
		default:
			return state;
	}
};

export interface MobileNavState {
	isSticky: boolean;
	isHidden: boolean;
	openNavItem: string | null;
	showSearch: boolean;
	isMenuOpen: boolean;
	areTransitionsSuspended: boolean;
	isScrolled: boolean;
	topOffset: number;
}

export type MobileNavAction =
	| {
			type: 'nav_position_updated';
			isSticky: boolean;
			isHidden: boolean;
			isScrolled: boolean;
			topOffset: number;
	  }
	| { type: 'toggled_search'; showSearch?: boolean }
	| { type: 'toggled_mobile_menu' }
	| { type: 'toggled_subnav_for_item'; navId?: string }
	| { type: 'clicked_or_focused_outside' }
	| { type: 'transitions_resumed' }
	| { type: 'desktop_viewport_entered' };
